<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Behfa Equipment Check-out</h5>


    <br />
    <br />

    <ul>
      <li>Click the relevant field before scanning.</li>
      <li>Press Enter to validate the scanned code.</li>
      <li>Press Esc to clear the form.</li>

    </ul>

    <br/>
    <br/>

    <form>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Equipment Exit Reason <i class="fa fa-arrow-down"></i> </label>
          <select class="custom-select" [(ngModel)]="DowloadType" name="DowloadType" (change)="OnChange_DowloadType()">
            <option value="1">For an On-site Customer Mission</option>
            <option value="2">For Equipment Calibration</option>
            <option value="3">For Equipment Repair</option>
            <option value="4">For Intermediate Equipment Check</option>
            <option value="5">For Proficiency Testing or Interlaboratory Comparison</option>
          </select>
        </div>
      </div>
      <div class="row" *ngIf="DowloadType=='1'">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Select Mission </label>
          <select class="custom-select" (change)="ReadData_Mission_Device()" [(ngModel)]="LetterSchedules" name="LetterSchedules">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Mission" [value]="item.id" >
              Decree Number {{item.userDsc}} - Letter Number {{item.code}} Date {{item.title}} - Time {{item.dsc}}
            </option>

          </select>
        </div>
      </div>

      <div class="table-responsive" *ngIf="DataList_Mission_Device.length>0">
        <br/>
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>System ID</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Cabinet</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Mission_Device">
              <td>{{DataList_Mission_Device.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td class="EnglishClm">{{item.technicalDsc}}</td>
              <td>
                <p *ngIf="!item.status" style="color: red;"> Check-out Not Registered <i class="fa fa-times-circle"></i> </p>
                <p *ngIf="item.status" style="color: green;"> Check-out Registered <i class="fa fa-check-circle"></i> </p>
              </td>

            </tr>
          </tbody>
        </table>
        <br/>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Click the field below before scanning the QR code. <i class="fa fa-arrow-down"></i>
          </label>
          <input #QRCodeInputDownload type="text" (keyup.enter)="QRCodeInputDownload_Enter()"
            (keyup.esc)="QRCodeInputDownload_Esc()"
            style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;" class="form-control EnglishClm"
            placeholder="Click here...">
          <p [hidden]="!Procssing"> Please wait... <i class="fa fa-spin fa-refresh"></i> </p>

        </div>
      </div>
      <div class="row">
        <p style="font-size: 20px;text-align: center;margin: auto;">
          I, <b>{{Fullname}}</b> confirm that all equipment listed below, removed on <b>{{nowDate}} </b>
          from the Behineh Farayand Azma Laboratory, is complete and free of defects.
          <br />
          <br />
          <input type="checkbox" [checked]="Check_Message" [(ngModel)]="Check_Message" name="Check_Message" />
          <b>I Confirm</b>
        </p>

      </div>

      <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeChangeDownload()" type="button"
        [disabled]="!Check_Message || Info_Download_List.length==0" class="btn btn-success" style="margin-right: 5px;"><i
          class="fa  fa-plus-circle"></i> Check Out Scanned Equipment </button>


      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeInputDownload_Enter()" type="button"
         class="btn btn-info" style="margin-right: 5px;"><i
          class="fa  fa-plus-circle"></i> Validate Equipment ID </button>

      <button *ngIf="!Procssing && FormSubmitted" (click)="ResetForm()" type="button" class="btn btn-danger"
        style="margin-right: 5px;"><i class="fa  fa-recycle"></i> Start Over  </button>

      <button routerLink="/DeviceBehfaDownloadUpload" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>

    <br />
    <br />

    <div class="row" *ngIf="Info_Download_List.length>0">
      <div class="form-group col-md-12">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Equipment Code</th>
                <th>Equipment Serial Number</th>
                <th *ngIf="!FormSubmitted">QR Code</th>
                <th *ngIf="FormSubmitted">System Message</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Info_Download_List">
                <td>{{Info_Download_List.indexOf(item)+1}}</td>
                <td>{{item.code}}</td>
                <td>{{item.title}}</td>
                <td *ngIf="item.id==0">{{item.dsc}}</td>
                <td *ngIf="item.id>0" style="color: green;">{{item.dsc}}</td>
                <td *ngIf="item.id<0" style="color: red;">{{item.dsc}}</td>
                <td>
                  <button *ngIf="!FormSubmitted" (click)="Info_Download_Remove(Info_Download_List.indexOf(item))"
                    class="btn btn-danger"><i class="fa fa-remove"></i> Delete </button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


  </div>
</div>
